import React, { useContext, useMemo } from 'react';
import '../styles/Homepage.css';
import Seo from './Seo';
import AppContext from '../components/context/AppContext';
import HeroSlideshow from './HeroSlideshow';
import CategoryList from './CategoryList';
import HomeBrands from './HomeBrands';
import { Row, Col } from 'react-bootstrap';

/**CONFIGURATION */
const LIST_KEY_SLICE_START = 0;
const LIST_KEY_SLICE_LENGTH = 15;

// Homepage component
// Rendered at the root path
const Homepage = () => {
    const { appContext } = useContext(AppContext);
    const appConfig = appContext.config.themeConfig;
    const slideShowItems = useMemo(() => [...appConfig.heroSection.images.map((section) => ({
        backgroundUrl: section.backgroundUrl,
    }))], [appConfig]);

    return (<>
        <Seo
            seoTitle={appConfig.seoTitle ?? appContext.config.storeName}
            seoType={'website'}
            seoDescription={appConfig.seoDescription}
            canonicalUrl={process.env.APP_URL}
        />
        <HeroSlideshow
            items={slideShowItems}
        />
        <Row
            className={'w-100 mx-auto'}>
            <Col
                md={2}
                className={'home--aside-content'}
            >
                <CategoryList />
            </Col>
            <Col
                md={8}
            >
                <div
                    className={'text-center'}
                >
                    <h2>Pool and Spa Parts Depot: Your One-Stop-Shop</h2>
                    <p>Pool and Spa Parts Depot is not just your ordinary shop. Here are the things you need to know about us.</p>
                    <h5>Why Pool and Spa Parts Depot?</h5>
                </div>
                {appConfig.homeAboutUs.map((section) => {
                    return (
                        <div
                            key={section.title}
                            className={'home--about-us'}
                        >
                            <h5>{section.title}</h5>
                            {section.descriptions.map((description) => {
                                return (
                                    <p
                                        key={`${section.title}-${description.slice(LIST_KEY_SLICE_START, LIST_KEY_SLICE_LENGTH)}`}
                                        dangerouslySetInnerHTML={{ __html: description }}
                                    />
                                );
                            })}
                        </div>
                    );
                })}
            </Col>
            <Col
                md={2}
                className={'home--aside-content'}
            >
                <HomeBrands />
            </Col>
        </Row>
    </>);
};

Homepage.propTypes = {};

export default Homepage;